import { ofType } from 'redux-observable'
import { ignoreElements, tap } from 'rxjs/operators'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import { getOperationCode } from 'store/selectors'
import { disableMixPanelTracking } from '../disable'

const mapStateToMPEvent = (eventName, clickName, state) => { // (eventName: string, state: State, action: onSeeAllTravelSalesClick)
  return {
    'Business': 'Travel',
    'Click Name': clickName,
    'Event Name': eventName,
    'Operation Code': getOperationCode(state),
    'Page Name': 'Catalogue Page'
  }
}

const clickBackToHomepageEpic = (
  actions$,
  state$
) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(Actions.application.SEE_ALL_TRAVEL_SALES_CLICK),
  tap(action => {
    const eventName = 'Click'

    const clickName = action.payload.isRedirectToNavigation ? 'Back to Travel search tool Banner' : 'Back to Le Voyage Homepage Banner'

    track(eventName, mapStateToMPEvent(eventName, clickName, state$.value), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default clickBackToHomepageEpic
